import * as React from "react";
import { AccountFormSelect } from "./utils";
import { Section } from "../../Common/Styles/containers";
import { IOrganization } from "../../../reducers/course-author/types";
import { ElementState, UserAccountPatchResponse } from "../types";
import { ErrorHeader } from "../../../App/Common/Components/FormComponents";
import styled from "styled-components";

const OwningOrgSection = styled(Section)`
  display: flex;
  flex-direction: column;
  width: fit-content;
  box-shadow: 0 0 0.5rem 0.25rem rgb(249, 162, 59, 0.5);
  padding: 2rem 2rem 3rem;
  height: auto;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    width: 25%;
  }
`;

const OwningOrgTitle = styled.h2`
  margin: 1rem 0;
`;

export interface OwningOrgProps {
  accountAlias: ElementState;
  selectedOrg: string;
  setModalMessage: (modalMsg: string) => void;
  setSelectedOrg: React.Dispatch<React.SetStateAction<string>>;
  changeOwningOrg: (newOwningOrgId: string) => Promise<UserAccountPatchResponse>;
  migrateAccountAlias: (oldOwningOrgId: string) => Promise<UserAccountPatchResponse>;
  organizations: IOrganization[];
}

export const OwningOrganization: React.FC<OwningOrgProps> = ({
  accountAlias,
  selectedOrg,
  setModalMessage,
  setSelectedOrg,
  organizations,
  changeOwningOrg,
  migrateAccountAlias,
}) => {
  const [errorMessage, setErroMessage] = React.useState<string | null>(null);

  const handleOnSelectOrg = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    changeOwningOrg(value).then(([err, res]) => {
      if (err || !res) {
        setErroMessage("Could not change owning organisation");
        return;
      }
      if (accountAlias.value) {
        migrateAccountAlias(selectedOrg).then(([er, r]) => {
          if (er || !r) {
            setErroMessage("Could not change owning organisation");
            return;
          }
        });
      }
      setSelectedOrg(value);
      setModalMessage("Successfully changed owning organisation");
    });
  };

  return (
    <OwningOrgSection data-testid="owning-org-component">
      <OwningOrgTitle>Root Org Admin Options</OwningOrgTitle>
      <AccountFormSelect
        legend="Owning Organisation"
        name="owning-org-select"
        footerNote={undefined}
        onChange={handleOnSelectOrg}
        value={selectedOrg}
        data-testid="select-owning-org"
      >
        {...organizations.map(org => (
          <option key={org.organizationId} value={org.organizationId}>
            {org.displayName}
          </option>
        ))}
        {errorMessage && <ErrorHeader>{errorMessage}</ErrorHeader>}
      </AccountFormSelect>
    </OwningOrgSection>
  );
};
